import { render, staticRenderFns } from "./transportFrom.vue?vue&type=template&id=39ca845b&scoped=true"
import script from "./transportFrom.vue?vue&type=script&lang=js"
export * from "./transportFrom.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39ca845b",
  null
  
)

export default component.exports